export enum ScorePredictorStatus {
  ComingSoon,
  EntryOpen,
  Answered,
  EntryClosedNoAnswer,
}
